import React from "react";
import ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.scss";
import App from "./components/App";
import * as serviceWorker from "./serviceWorker";
import {
	StylesProvider,
	createGenerateClassName,
} from "@material-ui/core/styles";
import AppContent from "./components/AssetReview/AppContent";
import { authProvider } from "./components/AuthProvider";
import { AzureAD } from "react-aad-msal";

const generateClassName = createGenerateClassName({
	seed: "asset",
	productionPrefix: "cjss",
});

window.mountAssetReviewStandAlone = (containerId) => {
	ReactDOM.render(
		<AzureAD provider={authProvider} forceLogin={true}>
			<StylesProvider generateClassName={generateClassName}>
				<React.StrictMode>
					<App authProvider={authProvider} />
				</React.StrictMode>
			</StylesProvider>
		</AzureAD>,
		document.getElementById(containerId)
	);
	serviceWorker.unregister();
};

window.mountAssetReview = (containerId) => {
	ReactDOM.render(
		<StylesProvider generateClassName={generateClassName}>
			<React.StrictMode>
				<App />
			</React.StrictMode>
		</StylesProvider>,
		document.getElementById(containerId)
	);

	serviceWorker.unregister();
};

window.unmountAssetReview = (containerId) => {
	ReactDOM.unmountComponentAtNode(document.getElementById(containerId));
};

window.mountAssetReviewContent = (containerId, app) => {
	const container = document.getElementById(containerId);
	if (container)
		ReactDOM.render(
			<StylesProvider generateClassName={generateClassName}>
				<React.StrictMode>
					<AppContent app={app} isReadOnly={true} />
				</React.StrictMode>
			</StylesProvider>,
			document.getElementById(containerId)
		);
	serviceWorker.unregister();
};

window.unmountAssetReviewContent = (containerId) => {
	const container = document.getElementById(containerId);
	if (container)
		ReactDOM.unmountComponentAtNode(document.getElementById(containerId));
};

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
